import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export const startGuidedTour = (steps = []) => {
  const availableSteps = steps.filter(
    (step) => !step.target || document.querySelector(step.target)
  );
  if (!availableSteps.length) return;

  const tour = driver({
    animate: true,
    allowClose: true,
    overlayColor: "#091f44",
    overlayOpacity: 0.45,
    showProgress: true,
    progressText: "{{current}} of {{total}}",
    nextBtnText: "Next",
    prevBtnText: "Back",
    doneBtnText: "Done",
    popoverClass: "piers-guided-tour",
    onPopoverRender: (popover) => {
      if (popover.footer.querySelector(".piers-tour-skip")) return;

      const skipButton = document.createElement("button");
      skipButton.type = "button";
      skipButton.className = "piers-tour-skip";
      skipButton.textContent = "Skip Tour";
      skipButton.addEventListener("click", () => tour.destroy());
      popover.footer.insertBefore(skipButton, popover.footerButtons);
    },
    steps: availableSteps.map((step) => ({
      element: step.target,
      onHighlightStarted: step.onHighlightStarted,
      onDeselected: step.onDeselected,
      popover: {
        title: step.title,
        description: step.description,
        side: step.placement || "bottom",
        align: "center",
      },
    })),
  });

  tour.drive();
};
